import { render } from "./AllProperties.vue?vue&type=template&id=071140e2&scoped=true"
import script from "./AllProperties.vue?vue&type=script&lang=js"
export * from "./AllProperties.vue?vue&type=script&lang=js"

import "./AllProperties.vue?vue&type=style&index=0&id=071140e2&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071140e2"]])

export default __exports__